// client/src/pages/results/ResultPortalList.js
import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SmartDataTable from "../../components/SmartDataTable";
import { useOrg } from "../orgs/org-context";

export default function ResultPortalList() {
  const navigate = useNavigate();
  const { activeOrgId, activeOrg } = useOrg();
  const [tableKey, setTableKey] = useState(0);

  const orgId =
    activeOrgId ||
    activeOrg?._id ||
    (typeof window !== "undefined" && localStorage.getItem("activeOrgId")) ||
    "none";

  // force reload on org change
  useEffect(() => setTableKey((k) => k + 1), [orgId]);

  // ---------------------------
  // columns (aligned style)
  // ---------------------------
  const columns = useMemo(
    () => [

      {
        label: "",
        type: "count",
        value: "__count",
        width: "48px",
        align: "center"
      },

      {
        label: "Name",
        value: "name",
        search: "name",
        width: "240px"
      },

      {
        label: "Project",
        value: "datasetId",
        width: "240px",
        type: "render",
        render: row =>
          row?.datasetId?.name ||
          row?.datasetId ||
          ""
      },

      {
        label: "Token",
        value: "token",
        width: "140px"
      },

      {
        label: "Active",
        value: "active",
        width: "80px",
        type: "render",
        render: r =>
          r.active
            ? 'Yes'
            : 'No'
      },

      {
        label: "Updated",
        value: "updatedAt",
        width: "180px",
        type: "render",
        render: r =>
          r.updatedAt
            ? new Date(
                r.updatedAt
              ).toLocaleString()
            : ''
      }

    ],
    []
  );

  // ---------------------------
  // buttons (aligned with your system)
  // ---------------------------
  const buttons = [

    {
      label: "View",
      class: "btn-blue",
      action:
        "/results/display/{token}"
    },

    {
      label: "Edit",
      class: "btn-green",
      action:
        "/results/setup/{_id}"
    },

    {
      label: "Delete",
      class: "btn-danger",
      action: "delete"
    }

  ];

  // ---------------------------
  // UI
  // ---------------------------
  return (
    <div className="datatable-page">
      <div
        className="datatable-header-row"
        style={{ justifyContent: "space-between" }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20 }}>
          Results Portals
        </div>
      </div>

      <SmartDataTable
        key={`results-${orgId}-${tableKey}`}
        config={{
          columns,

          // 🔥 THIS IS THE KEY CHANGE
          queryName: `/results/portal?orgId=${orgId}`,

          pageSize: 20,
          buttons,

          deletePathTemplate: "/results/settings/delete/{_id}", // make sure backend exists
          deleteMethod: "POST",

          headerActions: (
            <>
              <button
                className="btn-green add-new-button"
                onClick={() => navigate("/results/setup/new")}
              >
                Add New Results Portal
              </button>
            </>
          )
        }}
      />
    </div>
  );
}
